/**
 * We cannot use satisfies with next 12, which is a bumer. This
 * replicates the behavior... god bless this dev
 * https://stackoverflow.com/questions/56694082/as-const-combined-with-type
 **/
export function satisfy<TSatisfied>(): <T extends TSatisfied>(value: T) => T {
  return (value) => value;
}
export default satisfy;
